import { MuiTypography } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React from 'react';
import useStyles from './Card.styles';

const CardSkeleton = ({
  theme = Theme.light,
  cardColor,
  image = true,
  header = true,
  footer = true,
  lines = 3,
  row = false,
  animated = true,
}: any) => {
  const classes = useStyles({});
  const rootClassName = clsx(
    classes.root,
    classes.rootSkeleton,
    row && classes.rowSkeleton,
    !row && classes.gridSkeleton,
    `${theme}-theme`,
    `bg-color-${cardColor}`,
    animated && 'animated',
  );

  return (
    <div className={rootClassName} data-testid="qa-card-skeleton">
      <div>
        {image && (
          <div className={classes.image}>
            <div className={clsx(classes.skeleton, 'is-image', 'skeleton')} />
          </div>
        )}
        <div className={classes.content}>
          {header && (
            <header>
              <MuiTypography variant="h6" className={classes.title}>
                <div className={clsx(classes.skeleton, 'skeleton')} />
              </MuiTypography>
            </header>
          )}
          <main>
            <div className={classes.description}>
              {new Array(lines).fill(null).map((i, idx) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className={clsx(classes.skeleton, 'skeleton')} key={`skeleton_${idx}`} />
              ))}
            </div>
          </main>
          {footer && (
            <>
              <div className={classes.spacer} />
              <footer className={classes.footer}>
                <MuiTypography variant="overline" component="span" className="title">
                  <div className={clsx(classes.skeleton, 'skeleton')} />
                </MuiTypography>
              </footer>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;
